<div class="modal-header bg-light">
    <h5 class="modal-title">Ajouter un document</h5>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

    <div class="form-group" *ngIf="filesTypes.length > 2">
        <label for="type">Type</label>
        <select class="form-control" id="type" [(ngModel)]="doc.type">
            <option *ngFor="let type of filesTypes" [value]="type">{{ typeLabels?.[type] || (type | translate) }}</option>
        </select>
    </div>

    <div class="form-group">
        <label for="description">Description</label>
        <input type="text" class="form-control" id="description" [(ngModel)]="doc.description">
    </div>

    <div class="form-group">
        <input #inputFile type="file" (change)="changeListenerDoc($event)" [attr.accept]="accept || null" [hidden]="true" >
        <div class="file-selected" *ngIf="doc.fileName">
            <img [src]="getFileExt()" alt="" style="width:20px;margin-right:10px;"/>
            {{ doc.fileName }}
        </div>
        <div class="btn btn-primary btn-sm" (click)="addFile()" *ngIf="!doc.fileName">
            <fa-icon [icon]="['fas', 'file']" ></fa-icon> &nbsp;
            {{ 'Add.file' | translate }}
        </div>
        <div class="text-danger small mt-1" *ngIf="fileError">{{ fileError }}</div>
    </div>

</div>

<div class="modal-footer bg-light text-right">

    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!canSave">
        <fa-icon [icon]="['fas', 'check']"></fa-icon>&nbsp;
        Valider
    </button>

    <button ngbAutoFocus type="button" class="btn btn-secondary me-2" (click)="activeModal.close()">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>&nbsp;
        {{ 'cancel.modal.label' | translate | titlecase }}
    </button>


</div>